<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @submitReview="
        ({ shipmentPayStatementCode }) =>
          submitReview([shipmentPayStatementCode])
      "
      @checkbox-change="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        :check-count="checkCount"
        @submitReview="batchSubmitReview"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, shipmentPayVisible: false, checkedRow: [] }
  },
  computed: {
    checkCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentPayStatementListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-shipmentPayStatement-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async batchSubmitReview() {
      if (!this.checkCount) return
      const listCode = this.checkedRow.map(
        (item) => item.shipmentPayStatementCode
      )

      // 判断是否都是相同类型的
      const { payTo: firstPayTo } = this.checkedRow[0]
      const payToEvery = this.checkedRow.every(
        (item) => item.payTo == firstPayTo
      )

      if (payToEvery) {
        this.submitReview(listCode)
        return
      }
      const h = this.$createElement
      const confirm = await this.$confirm(
        h('div', null, [
          h(
            'p',
            null,
            this.$l('tips_confirm_submitReview') ||
              '您所选的结算单存在不同结算方类型，是否确认提交审核？'
          ),
          h('p', null, [
            h('p', null, [
              h(
                'i',
                { style: 'color: teal' },
                this.$l('tips_confirm_submitReview_freight') || '货代：'
              ),
              h(
                'span',
                null,
                this.$l('tips_confirm_submitReview_freight_context') ||
                  '将合并为一个费用填报单并提交OA请款 '
              ),
            ]),
            h('p', null, [
              h(
                'i',
                { style: 'color: teal' },
                this.$l('tips_confirm_submitReview_transport') || '运输公司：'
              ),
              h(
                'span',
                null,
                this.$l('tips_confirm_submitReview_transport_context') ||
                  '将修改为提交审核状态 '
              ),
            ]),
          ]),
        ]),
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText:
            this.$l('tips_confirm_submitReview_confirmButtonText') || '提交',
          cancelButtonText:
            this.$l('tips_confirm_submitReview_cancelButtonText') || '取消提交',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.submitReviewApi(listCode)
    },
    submitReview(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.submitReviewApi(listCode)
      })
    },
    async submitReviewApi(listCode) {
      const linkUrl = this.$joinURL(`/opview/shipment/expense`, {
        joinOrigin: true,
        joinBasePath: false,
      })
      this.loadingOpen()
      const res = await this.$api
        .shipmentPayStatementSubmitReviewApi({ listCode, linkUrl })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.tips_submission_failed') || '提交失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.checkedRow = []
      this.$refs.main.clearCheckboxRows()
      this.reload()
    },
  },
}
</script>
